<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <div>
      <!-- 身份证 -->
      <div class="color-f-bg">
        <!-- 照片信息 -->
        <div class="flex-s padding-t-15 padding-b-10 page-padding-l-r">
          <!-- Label-->
          <div style="width: 95px;">
            <span>证件照</span>
          </div>
          <!-- 人像面 -->
          <div class="align-center title-5 say-color" style="margin-right: 0.5rem;">
            <div class="id-card-style" @click="onCameraImgClick('renXiang')">
              <img v-if="renXiang.webUrl" class="img" :src="renXiang.webUrl" />
              <svg-icon v-else class-name="img" icon-class="authenticate-headshot" />
            </div>
            <div class="id-card-tips">头像页</div>
          </div>
          <!-- 国徽面 -->
          <div class="align-center title-5 say-color">
            <div class="id-card-style" @click="onCameraImgClick('guoHui')">
              <img v-if="guoHui.webUrl" class="img" :src="guoHui.webUrl" />
              <svg-icon v-else class-name="img" icon-class="authenticate-emblem" />
            </div>
            <div class="id-card-tips">国徽页</div>
          </div>
        </div>
        <!-- 身份信息 -->
        <!-- 商户姓名 -->
        <div v-if="renXiang.webUrl" class="margin-l-15">
          <div class="line" />
          <div class="flex-s form-item">
            <div style="width: 95px;">姓名</div>
            <input type="tel" class="flex-1" placeholder="请输入姓名" v-model.trim="formData.idCardName" />
          </div>
        </div>
        <!-- 法人身份证 -->
        <div v-if="renXiang.webUrl" class="margin-l-15">
          <div class="line" />
          <div class="flex-s form-item">
            <div style="width: 95px;">证件号码</div>
            <input type="tel" class="flex-1" placeholder="请输入证件号码" v-model.trim="formData.idCardNum" disabled />
          </div>
        </div>
        <!-- 有效期 -->
        <div v-if="guoHui.webUrl" class="margin-l-15">
          <div class="line" />
          <div class="flex-s form-item">
            <div style="width: 95px;">有效期</div>
            <input type="tel" class="flex-1" placeholder="请输入有效期" v-model.trim="formData.dateOf" disabled />
          </div>
        </div>
      </div>
      <!-- 2024.10.30 活体、信用卡切换 -->
      <!-- 切换提示 -->
      <div v-if="btnStatus > 1" class="tips page-padding-l-r">
        <span class="txt">{{ faceCreditSwitchTips }}</span>
      </div>
      <!-- 切换按键-->
      <div v-if="btnStatus > 1 && realAuthenticationType > 1" class="color-f-bg">
        <div class="flex-c">
          <div class="flex-1" @click="onFaceCreditCardClick(2)">
            <div class="card" :class="{ 'selected': faceCreditSelectedCard === 2 }">信用卡</div>
          </div>
          <div class="flex-1" @click="onFaceCreditCardClick(1)">
            <div class="card" :class="{ 'selected': faceCreditSelectedCard === 1 }">人脸识别</div>
          </div>
        </div>
        <div class="line" />
      </div>
      <!-- 信用卡表单 2024.10.30 新加 -->
      <div v-if="btnStatus > 1" v-show="faceCreditSelectedCard === 2">
        <!-- 表单 -->
        <div class="color-f-bg">
          <!-- 信用卡照片 -->
          <div class="padding-t-10 padding-b-10 margin-l-15">
            <div class="flex-s">
              <div style="width: 95px;">信用卡照片</div>
              <div class="id-card-style" @click="onCameraImgClick('xinYongKa')">
                <img v-if="xinYongKa.webUrl" class="img" :src="xinYongKa.webUrl" />
                <svg-icon v-else icon-class="camera_comm" class-name="img" />
              </div>
            </div>
          </div>
          <!-- 卡号 -->
          <div class="margin-l-15">
            <div class="line" />
            <div class="flex-s form-item">
              <div style="width: 95px;">卡号</div>
              <input type="tel" class="flex-1" maxlength="23" :placeholder="creditCardPlaceholder"
                v-model.trim="formData.creditCardNo" :disabled="!creditCardHasError" @input="onBankCardInput" />
            </div>
          </div>
          <!-- 手机号 -->
          <div class="margin-l-15">
            <div class="line" />
            <div class="flex-s form-item">
              <div style="width: 95px;">手机号</div>
              <input type="tel" class="flex-1" maxlength="13" placeholder="请输入银行预留手机号"
                v-model.trim="formData.creditCardMobile" @input="onMobileInput" />
            </div>
          </div>
          <!-- 验证码 -->
          <div v-if="realAuthenticationSmsCode" class="margin-l-15">
            <div class="line" />
            <div class="flex-s form-item">
              <div style="width: 95px;">验证码</div>
              <input type="tel" class="flex-1" maxlength="6" placeholder="请输入短信验证码"
                v-model.trim="formData.creditCardCode" @input="onCreditCodeInput" />
              <div class="code" :class="{ 'disabled': creditCodeDisabled }" @click="onCreditCodeClick">{{ creditCodeText
                }}</div>
            </div>
          </div>
        </div>
        <!-- 信用卡提示信息 -->
        <div v-if="realAuthenticationSmsCode" class="tips page-padding-l-r">
          <span class="txt">短信验证码将发送至银行预留手机号，请注意查收</span>
        </div>
      </div>
      <!-- 人脸识别 -->
      <div v-if="btnStatus > 1" v-show="faceCreditSelectedCard === 1">
        <!-- 传照片 -->
        <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r color-f-bg">
          <div style="width: 95px;">人脸识别</div>
          <div class="faceStyle" @click="onCameraImgClick('renLian')">
            <img v-if="renLian.webUrl" class="img" :src="renLian.webUrl" />
            <svg-icon v-else icon-class="camera_face" class-name="img" />
          </div>
        </div>
        <!-- 提示 -->
        <div class="tips page-padding-l-r title-6 say-color">
          如遇活体检测失败，可以选择
          <span class="theme-color" @click="resetCameraInfo('renLian', 2)">重新识别</span>或
          <span class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
        </div>
      </div>
      <!-- 提示1 -->
      <div v-if="(renXiang.webUrl || guoHui.webUrl) && btnStatus === 1"
        class="flex padding-t-10 padding-b-10 page-padding-l-r title-6 say-color">
        <div class="flex-1">
          <div v-if="showGlobalPhotoTips" class="say-color">
            {{ renLian.photoTips }}
          </div>
          <div v-else class="say-color">
            如信息有误，请重新拍照
          </div>
        </div>
        <div>
          <div class="theme-color" @click="resetCameraInfo('renXiang'), resetCameraInfo('guoHui')">重新拍照</div>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div class="padding-t-10 padding-b-10 page-padding-l-r"
        :class="{ 'margin-t-20': btnStatus > 1 && !realAuthenticationSmsCode }">
        <mt-button type="primary" size="large" v-if="renXiang.webUrl && guoHui.webUrl" :disabled="btnStatus === 2"
          @click="onSubmitBtnClick">{{ btnName }}</mt-button>
      </div>
    </div>
    <!-- 百度活体弹窗 -->
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
    <!-- 信用卡识别失败的弹窗 2024.11.11 -->
    <mt-popup class="credit-popup" v-model="creditPopupVisible" :closeOnClickModal="false">
      <div class="popup">
        <div class="content">
          <span class="txt">银行卡识别失败，请重新拍照识别或申请人工审核(需手动输入银行卡卡号)</span>
        </div>
        <div class="btn" @click="onAgainXykCameraClick">重新拍照</div>
        <div class="btn" @click="onXykManualClick">申请人工审核</div>
        <div class="btn cancel" @click="onCreditPopupCancelClick">取消</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_FACE_PHOTO_TIPS */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import Liveness from '@/components/Liveness';
import CryptoJS from 'crypto-js'; // 实现md5加密
import { mapGetters, mapMutations } from 'vuex';
import { formatDateLongStr } from '@/utils/utils.js';
import { CusToast, CusAlert, CusConfirm, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { controlBankCardInput, controlMobileInput } from '@/utils/format';
import { validateMobile, validateBankCard } from '@/utils/validate';
import { GetIdCardFrontUrlV2, GetIdCardBackUrlV2, GetIdNameFaceServiceUrl, UpdateIdCardInfoFaceActive, YMTivingThing, GetBankCardContent, GetVerCardMobileCode } from '@/api/weChat.js';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'IdCardAuthCredit',
  components: { SvgIcon, Liveness },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        popupVisible: false,
        photoTips: PUBLIC_FACE_PHOTO_TIPS,
      },
      xinYongKa: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
        address: '',
        familyName: '',
        birthday: '',
        sex: '',
        office: '',
        dateOfIssue: '',
        dateOfInvalid: '',
        dateOf: '',
        creditCardNo: '',
        creditCardMobile: '',
        creditCardCode: '',
        creditCardMd5: '',
      },
      // 储蓄卡认证状态
      bankCardStatus: 0,
      // 活体认证类型
      faceDetectActivity: 0,
      // 是否需要手持
      userIsNeedHandIdentityCard: false,
      // 实名认证方式 默认0 ，0:人脸公安对比 ;1: 信用卡认证; 2: 人脸识别、信用卡均可;
      realAuthenticationType: 0,
      // 实名认证-信用卡认证-短信验证码的控制标识  默认1，0:不需要，1:需要
      realAuthenticationSmsCode: 1,
      // 身份证识别批次号 2023.4.23
      idCardBatchNo: '',
      // 按钮当前的状态
      btnStatus: 1,
      // 百度活体弹窗开关
      livingFacePopupVisible: false,
      // 信用卡识别失败弹窗开关
      creditPopupVisible: false,
      // 人脸、信用卡切换选中项 -- 1.人脸认证，2.信用卡认证；
      faceCreditSelectedCard: 1,
      // 验证码按钮text
      creditCodeText: '获取验证码',
      // 验证码有效性
      creditCodeDisabled: false,
      // 验证码计时器
      timing: null,
      // 是否显示人脸的公共提示信息
      showGlobalPhotoTips: false,
      // 信用卡识别错误标识，可以控制信用卡卡号是否可以输入，默认为false不可输入 2024.11.11
      creditCardHasError: false,
      // 信用卡输入框提示信息
      creditCardPlaceholder: '请对准银行卡拍照并识别',
    };
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    // 按钮状态名称
    btnName() {
      let name = '提交';
      switch (this.btnStatus) {
        case 1:
          name = '提交';
          break;
        default:
          name = '下一步';
      }
      return name;
    },
    // 人脸、信用卡切换提示
    faceCreditSwitchTips() {
      if (this.realAuthenticationType === 1) return '信用卡信息';
      if (this.realAuthenticationType === 2) return '信用卡/人脸信息(2选1)';
      return '';
    },
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.bankCardStatus = parseInt(this.$route.query.bankcardstatus);
      this.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
      this.userIsNeedHandIdentityCard = this.$route.query.needhandidcard === 'true';
      this.realAuthenticationType = parseInt(this.$route.query.realauthtype);
      this.realAuthenticationSmsCode = parseInt(this.$route.query.realauthsmscode);
      this.faceCreditSelectedCard = this.realAuthenticationType < 2 ? this.realAuthenticationType + 1 : this.realAuthenticationType;
      this.idCardBatchNo = `${formatDateLongStr(new Date())}${String(Math.floor(Math.random() * 9000000000000 + 1000000000000))}`;
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.btnStatus = parseInt(this.$route.query.btnstatus);
        this.idCardBatchNo = this.$route.query.idcardbatchno;
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
        this.renLian.webUrl = decodeURIComponent(this.$route.query.rlweburl).replace('|', '?');
        this.xinYongKa.webUrl = decodeURIComponent(this.$route.query.xykweburl).replace('|', '?');
        this.formData.idCardName = this.$route.query.idcardname;
        this.formData.idCardNum = this.$route.query.idcardnum;
        this.formData.address = this.$route.query.address;
        this.formData.familyName = this.$route.query.familyname;
        this.formData.birthday = this.$route.query.birthday;
        this.formData.sex = this.$route.query.sex;
        this.formData.office = this.$route.query.office;
        this.formData.dateOfIssue = this.$route.query.dateofissue;
        this.formData.dateOfInvalid = this.$route.query.dateofinvalid;
        this.formData.dateOf = `${this.$route.query.dateofissue} - ${this.$route.query.dateofinvalid}`;
        this.formData.creditCardNo = this.$route.query.cardno;
        this.formData.creditCardMobile = this.$route.query.cardmobile;
        this.formData.creditCardCode = this.$route.query.cardcode;
        this.formData.creditCardMd5 = this.$route.query.cardmd5;
        switch (imgType) {
          case 'renXiang':
            this.getIdCardFrontUrlV2();
            break;
          case 'guoHui':
            this.getIdCardBackUrlV2();
            break;
          case 'ymt':
            this.faceCreditSelectedCard = 1;
            this.yMTivingThing();
            break;
          case 'xinYongKa':
            this.faceCreditSelectedCard = 2;
            this.getBankCardContent();
            break;
        }
      }
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      name === 'renLian' && (this[name].photoTips = PUBLIC_FACE_PHOTO_TIPS);
      this.btnStatus = staus;
    },
    // 跳人工审核
    jumpManualAudit() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
        CusAlert('已为您申请人工审核，预计将在1个工作日内完成。请继续完成后续认证流程，否则将无法通过人工审核', () => {
          this.replacePage('auth/manualreview', {
            idcardname: this.formData.idCardName,
            bankcardstatus: this.bankCardStatus,
            idcardbatchno: this.idCardBatchNo,
            facecreditindex: this.faceCreditSelectedCard,
          });
        });
      });
    },
    // 跳转信用卡人工审核
    jumpCreditManualAudit(msg, auditGuid) {
      CusAlert(msg, () => {
        this.replacePage('auth/manualreview', {
          idcardname: this.formData.idCardName,
          bankcardstatus: this.bankCardStatus,
          auditguid: auditGuid,
          facecreditindex: this.faceCreditSelectedCard,
        });
      });
    },
    // 人脸识别不同方式不同处理
    jumpToLiveness() {
      let data = null;
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 跳转银行卡识别
    jumpToBankCardIdentify() {
      //2024.11.15 添加判断如果没有进入人工审核流程，才能再次识别信用卡信息
      // 反之一旦进入信用卡流程，就不让再次识别信用卡了
      if (!this.creditCardHasError) {
        const data = this.createPostMessage('xinYongKa');
        wx.miniProgram.postMessage({ data });
        wx.miniProgram.redirectTo({
          url: '/pages/media/media',
        });
      }
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'IdCardAuthCredit',
        imgType: imgTypeStr,
        btnStatus: this.btnStatus,
        idCardBatchNo: this.idCardBatchNo,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        idCardName: this.formData.idCardName,
        idCardNum: this.formData.idCardNum,
        address: this.formData.address,
        familyName: this.formData.familyName,
        birthday: this.formData.birthday,
        sex: this.formData.sex,
        office: this.formData.office,
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        dateOfIssue: this.formData.dateOfIssue,
        dateOfInvalid: this.formData.dateOfInvalid,
        rlWebUrl: encodeURIComponent(this.renLian.webUrl.replace('?', '|')),
        xykWebUrl: encodeURIComponent(this.xinYongKa.webUrl.replace('?', '|')),
        creditCardNo: this.formData.creditCardNo,
        creditCardMobile: this.formData.creditCardMobile,
        creditCardCode: this.formData.creditCardCode,
        creditCardMd5: this.formData.creditCardMd5,
      };
    },
    // 验证手机号码
    validateMobileNumVal() {
      const val = this.formData.creditCardMobile.replace(/\s/gi, '');
      if (val === '') {
        CusToast('手机号码不能为空');
        return 'err';
      }
      const regExp = PUBLIC_MOBILE_REGEXP;
      if (!regExp.test(val)) {
        CusToast('手机号码格式不正确');
        return 'err';
      }
      return 'ok';
    },
    // 结束倒计时
    endTiming() {
      clearInterval(this.timing);
      this.creditCodeDisabled = false;
      this.creditCodeText = '获取验证码';
    },
    // 调用接口上传人脸照片
    updateIdCardInfoFaceActive(url, callback = null) {
      CusLoadingOpen();
      UpdateIdCardInfoFaceActive({ url, batchNumber: this.idCardBatchNo })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            () => {
              callback && callback();
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 上传数据到服务器
    upLoadData() {
      CusLoadingOpen();
      let data = {};
      // 判断是人脸认证还是信用卡认证
      if (this.faceCreditSelectedCard === 1) {
        // faceCreditSelectedCard=1为人脸认证
        data = {
          batchNo: this.idCardBatchNo,
          url: this.renLian.webUrl,
          realAuthenticationType: 0,
        };
      } else {
        // 反之则认为faceCreditSelectedCard=2，信用卡认证
        data = {
          batchNo: this.idCardBatchNo,
          bankCardUrl: this.xinYongKa.webUrl,
          bankCardNum: this.formData.creditCardNo.replace(/\s/gi, ''),
          bankMobile: this.formData.creditCardMobile.replace(/\s/gi, ''),
          smsCode: this.formData.creditCardCode.replace(/\s/gi, ''),
          realAuthenticationType: 1,
          isAudit: this.creditCardHasError ? 1 : 0, // 2024.11.11 如果申请人工审核则改变isAudit入参参数
        };
      }
      GetIdNameFaceServiceUrl(data)
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            // 2024.11.1 添加判断，人脸认证才调用updateIdCardInfoFaceActive接口
            if (this.faceCreditSelectedCard === 1) {
              // faceCreditSelectedCard=1为人脸认证
              CusAlert('认证成功', () => {
                this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
                  if (this.userIsNeedHandIdentityCard) {
                    //  如果需要手持，则跳转手持页面
                    this.replacePage('auth/handidcard', {
                      idcardname: this.formData.idCardName,
                      idcardnum: this.formData.idCardNum,
                    });
                  } else {
                    // 向小程序发消息，更新状态
                    wx.miniProgram.postMessage({ data: { page: 'refresh' } });
                    // 2024.11.1 添加判断用户储蓄卡状态，0才进添卡页面，其它状态直接返回首页
                    if (this.bankCardStatus === 0) {
                      // 2.跳转小程序添加储蓄卡的页面
                      wx.miniProgram.redirectTo({
                        url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
                      });
                    } else {
                      wx.miniProgram.navigateBack();
                    }
                  }
                });
              });
            } else {
              // 反之则认为faceCreditSelectedCard=2，信用卡认证
              // 2024.11.11 新增判断是否需要跳转信用卡人工审核
              if (res.innerCode === 1005) {
                // 如果innerCode为1005，则认为需要跳转到人工审核
                this.jumpCreditManualAudit(res.msg, res.data.auditGuid);
              } else {
                // 反之，则还是走正常流程
                CusAlert('认证成功', () => {
                  if (this.userIsNeedHandIdentityCard) {
                    //  如果需要手持，则跳转手持页面
                    this.replacePage('auth/handidcard', {
                      idCardName: this.formData.idCardName,
                      idCardNum: this.formData.idCardNum,
                    });
                  } else {
                    // 向小程序发消息，更新状态
                    wx.miniProgram.postMessage({ data: { page: 'refresh' } });
                    // 2.跳转小程序添加储蓄卡的页面
                    // 2024.11.1 添加判断用户储蓄卡状态，0才进添卡页面，其它状态直接返回首页
                    if (this.bankCardStatus === 0) {
                      wx.miniProgram.redirectTo({
                        url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
                      });
                    } else {
                      wx.miniProgram.navigateBack();
                    }
                  }
                });
              }
            }
          } else {
            // 如果出错，给出提示
            // 2024.11.1 添加判断，人脸认证才调用updateIdCardInfoFaceActive接口
            if (this.faceCreditSelectedCard === 1) {
              CusAlert(res.msg, () => {
                // faceCreditSelectedCard=1，人脸认证
                this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
                  this.btnStatus = 3;
                  // 如果innerCode等于7776，则跳转至人工审核页面
                  if (res.innerCode === 7776) {
                    this.replacePage('auth/manualreview', {
                      idcardname: this.formData.idCardName,
                      bankcardstatus: this.bankCardStatus,
                      idcardbatchno: this.idCardBatchNo,
                      facecreditindex: this.faceCreditSelectedCard,
                    });
                  }
                });
              });
            } else {
              // 反之则认为faceCreditSelectedCard=2，信用卡认证
              this.btnStatus = 3;
              // 如果innerCode等于7776，则跳转至信用卡的人工审核页面
              if (res.innerCode === 1005 || res.innerCode === 7776) {
                this.jumpCreditManualAudit(res.msg, res.data.auditGuid);
              }
            }
          }
        })
        .catch(err => {
          CusLoadingClose();
          CusAlert(err.msg);
        });
    },
    // 调用接口识别身份证正面信息
    getIdCardFrontUrlV2() {
      CusLoadingOpen();
      GetIdCardFrontUrlV2({
        url: this.renXiang.webUrl,
        batchNo: this.idCardBatchNo,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 2024.11.6 添加innerCode为1002时，弹窗显示一下错误提示
              if (res.innerCode === 1002) {
                CusAlert(res.msg, () => {
                  this.formData.idCardName = res.data.Name;
                  this.formData.idCardNum = res.data.IdCardNum;
                  this.formData.address = res.data.Address;
                  this.formData.familyName = res.data.FamilyName;
                  this.formData.birthday = res.data.Birthday;
                  this.formData.sex = res.data.Sex;
                });
              } else {
                this.formData.idCardName = res.data.Name;
                this.formData.idCardNum = res.data.IdCardNum;
                this.formData.address = res.data.Address;
                this.formData.familyName = res.data.FamilyName;
                this.formData.birthday = res.data.Birthday;
                this.formData.sex = res.data.Sex;
              }
            },
            (code, msg) => {
              msg &&
                CusAlert(msg, () => {
                  this.resetCameraInfo('renXiang');
                });
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口识别身份证背面信息
    getIdCardBackUrlV2() {
      CusLoadingOpen();
      GetIdCardBackUrlV2({
        url: this.guoHui.webUrl,
        batchNo: this.idCardBatchNo,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 现阶段此接口有BUG，未识别出背面时，code还是为0
              // 特用判断msg的方式补救一下
              // 2024.11.6 添加innerCode为1002时，只弹窗显示错误
              if (res.msg !== '') {
                if (res.innerCode === 1002) {
                  CusAlert(res.msg);
                } else {
                  CusAlert(res.msg, () => {
                    this.resetCameraInfo('guoHui');
                  });
                }
              }
              this.formData.office = res.data.Office;
              this.formData.dateOfIssue = res.data.DateOfIssue;
              this.formData.dateOfInvalid = res.data.DateOfInvalid;
              this.formData.dateOf = `${res.data.DateOfIssue} - ${res.data.DateOfInvalid}`;
            },
            (code, msg) => {
              msg &&
                CusAlert(msg, () => {
                  this.resetCameraInfo('guoHui');
                });
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口识别信用卡信息
    getBankCardContent() {
      CusLoadingOpen();
      GetBankCardContent({ url: this.xinYongKa.webUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 提示只能添加信用卡
              if (res.data.BankCardType === 1) {
                CusToast('只能添加信用卡');
                this.formData.creditCardNo = '';
                this.resetCameraInfo('xinYongKa', 2);
                return;
              }
              // 判断如果有手机号和验证码，则将按钮状态置为可点击
              if (this.formData.creditCardMobile && this.formData.creditCardCode) {
                this.btnStatus = 3;
              }
              // 存储银行卡号
              this.formData.creditCardNo = res.data.BankCardNumber;
            },
            (code, msg) => {
              // 2024.11.11 信用卡识别次数用完后可以跳转人工审核
              if (code === 9990) {
                CusAlert('今天银行卡识别次数已用完，请手动输入银行卡卡号并申请人工审核', () => {
                  this.formData.creditCardNo = '';
                  this.creditCardHasError = true;
                  this.creditCardPlaceholder = '请输入本人信用卡卡号';
                });
              } else {
                // 2024.11.11 新增信用卡识别失败时可以提交人工审核
                if (res.innerCode === 1005) {
                  this.creditPopupVisible = true;
                } else {
                  msg &&
                    CusAlert(msg, () => {
                      this.resetCameraInfo('xinYongKa', 2);
                      this.formData.creditCardNo = '';
                    });
                }
              }
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口获取短信验证码
    getVerCardMobileCode() {
      CusLoadingOpen();
      GetVerCardMobileCode({
        mobileNumber: this.formData.creditCardMobile.replace(/\s/gi, ''),
        bankCardNum: this.formData.creditCardNo.replace(/\s/gi, ''),
        codeType: 11,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              let time = 60;
              this.formData.creditCardMd5 = res.data;
              this.creditCodeDisabled = true;
              const sendSms = () => {
                if (time > 0) {
                  this.creditCodeText = `重新获取(${time})`;
                  time -= 1;
                } else {
                  this.endTiming();
                }
                return sendSms;
              };
              this.timing = setInterval(sendSms(), 1000);
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.renLian.webUrl = this.renLian.webUrl;
              this.renLian.fileUrl = this.renLian.webUrl;
              this.renLian.base64 = this.renLian.webUrl;
              this.btnStatus = 3;
            },
            (code, msg) => {
              msg &&
                CusAlert(msg, () => {
                  this.renLian.webUrl = this.renLian.webUrl;
                  this.renLian.fileUrl = this.renLian.webUrl;
                  this.renLian.base64 = this.renLian.webUrl;
                  this.btnStatus = 2;
                });
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 人脸、信用卡切换点击事件
    onFaceCreditCardClick(index) {
      // 切换重置提示
      // 判断是否可以切换
      if (this.realAuthenticationType === 2) {
        // 1为进入人脸
        if (index === 1) {
          // 判断信用卡表单是否为空
          if (this.formData.creditCardNo || this.formData.creditCardMobile || this.formData.creditCardCode) {
            // 不为空给出提示
            CusConfirm('信用卡/人脸信息(2选1)，确定清空信用卡信息吗？', () => {
              this.faceCreditSelectedCard = 1;
              this.resetCameraInfo('xinYongKa', 2);
              this.formData.creditCardNo = '';
              this.formData.creditCardMobile = '';
              this.formData.creditCardCode = '';
            });
          } else {
            this.faceCreditSelectedCard = 1;
          }
        }
        // 2为进入信用卡
        if (index === 2) {
          // 判断信用卡表单是否为空
          if (this.renLian.webUrl) {
            // 不为空给出提示
            CusConfirm('信用卡/人脸信息(2选1)，确定清空人脸信息吗？', () => {
              this.faceCreditSelectedCard = 2;
              this.resetCameraInfo('renLian', 2);
            });
          } else {
            this.faceCreditSelectedCard = 2;
          }
        }
      } else {
        this.faceCreditSelectedCard = index;
      }
    },
    // 基本信息-银行卡号输入事件
    onBankCardInput() {
      // 判断如果有手机号和验证码，则将按钮状态置为可点击
      // 2024.11.19 新加判断是否需要使用短信验证码
      if (this.realAuthenticationSmsCode) {
        if (this.formData.creditCardMobile && this.formData.creditCardCode) {
          this.btnStatus = 3;
        }
      } else {
        if (this.formData.creditCardMobile) {
          this.btnStatus = 3;
        }
      }

      // 格式化并存储银行卡号
      this.formData.creditCardNo = controlBankCardInput(this.formData.creditCardNo);
    },
    // 基本信息-手机号输入事件
    onMobileInput() {
      // 2024.11.19 新加判断是否需要使用短信验证码
      if (this.realAuthenticationSmsCode) {
        // 判断如果有银行卡号和验证码，则将按钮状态置为可点击
        if (this.formData.creditCardNo && this.formData.creditCardCode) {
          this.btnStatus = 3;
        }
      } else {
        if (this.formData.creditCardNo) {
          this.btnStatus = 3;
        }
      }

      // 格式化并存储手机号
      this.formData.creditCardMobile = controlMobileInput(this.formData.creditCardMobile);
    },
    // 邀请码input事件
    onCreditCodeInput() {
      // 判断如果有银行卡号和手机号，则将按钮状态置为可点击
      if (this.formData.creditCardNo && this.formData.creditCardMobile) {
        this.btnStatus = 3;
      }
      // 获取正在输入的最后一位字符
      const last = this.formData.creditCardCode.charAt(this.formData.creditCardCode.length - 1);
      // 自动将非法字符替换成空
      this.formData.creditCardCode = '1234567890'.indexOf(last) < 0 ? this.formData.creditCardCode.replace(last, '') : this.formData.creditCardCode;
    },
    // 验证码点击事件
    onCreditCodeClick() {
      // 失效时直接退出
      if (this.creditCodeDisabled) return;
      // 验证-手机号非法时直接退出
      if (this.validateMobileNumVal() === 'err') return;
      // 调用接口
      this.getVerCardMobileCode();
    },
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case 'renXiang':
        case 'guoHui':
          // 2024.11.15 添加btnStatus为1时才允许识别身份证
          // 其它情况则不允许识别身份证
          if (this.btnStatus === 1) {
            const data = this.createPostMessage(type);
            wx.miniProgram.postMessage({ data });
            wx.miniProgram.redirectTo({
              url: '/pages/media/media',
            });
          }
          break;
        case 'renLian':
          this.jumpToLiveness();
          break;
        case 'xinYongKa':
          this.jumpToBankCardIdentify();
          break;
      }
    },
    // 提交数据按钮点击
    onSubmitBtnClick() {
      switch (this.btnStatus) {
        case 1:
          this.btnStatus = 2;
          break;
        case 3:
          // 验证数据
          // 判断是否是认证信用卡
          if (this.faceCreditSelectedCard === 2) {
            // 验证银行卡号
            const cardResult = validateBankCard(this.formData.creditCardNo);
            if (cardResult === 1) {
              CusToast('银行卡号不能为空');
              return;
            }
            if (cardResult === 2) {
              CusToast('银行卡号长度不正确');
              return;
            }
            // 验证手机号
            const mobileResult = validateMobile(this.formData.creditCardMobile);
            if (mobileResult === 1) {
              CusToast('手机号不能为空');
              return;
            }
            if (mobileResult === 2) {
              CusToast('手机号格式不合法');
              return;
            }
            // 2024.11.19 加入后台控制开关
            if (this.realAuthenticationSmsCode) {
              // 验证短信码
              const codeMd5 = CryptoJS.MD5(this.formData.creditCardCode).toString();
              if (this.formData.creditCardMd5 !== codeMd5.toUpperCase()) {
                CusToast('验证码有误，请确认后重新输入');
                return;
              }
            }
          }
          // 提交数据
          this.upLoadData();
          break;
      }
    },
    // 信用卡识别失败弹窗重新拍照事件
    onAgainXykCameraClick() {
      this.resetCameraInfo('xinYongKa', 2);
      this.formData.creditCardNo = '';
      this.creditCardHasError = false;
      this.creditCardPlaceholder = '请对准银行卡拍照并识别';
      this.creditPopupVisible = false;
    },
    // 信用卡识别失败弹窗人工审核事件
    onXykManualClick() {
      this.formData.creditCardNo = '';
      this.creditCardHasError = true;
      this.creditCardPlaceholder = '请输入本人信用卡卡号';
      this.creditPopupVisible = false;
    },
    // 信用卡识别失败弹窗取消事件
    onCreditPopupCancelClick() {
      this.creditPopupVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.padding-t-15 {
  padding-top: 0.75rem;
}

.line {
  height: 1px;
  border-bottom: 1px solid $border-color;
}

.id-card-style {
  width: 6rem;
  height: 4rem;
  vertical-align: middle;
  overflow: hidden;
  @include dynamic-color;

  .img {
    width: 100%;
    height: 100%;
  }
}

.id-card-tips {
  line-height: 1;
  padding-top: 0.2rem;
}

.tips {
  line-height: 1;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  .txt {
    font-size: $title5;
    color: $explain-color;
  }
}

.card {
  width: 40%;
  padding: 0.7rem 0 0.65rem;
  margin: auto;
  line-height: 1;
  font-size: $title4;
  color: $word-color;
  text-align: center;
  border-bottom: 0.1rem solid #fff;

  &.selected {
    @include dynamic-color;
    @include dynamic-border-color;
  }
}

.form-item {
  line-height: 1;
  padding: 0.6rem 0;

  input[type='tel'] {
    width: 100%;
    font-size: $title3;
    outline: 0;
    padding: 0;
    border: 0;

    &:disabled {
      background-color: $highlight-color;
      color: $word-color;
    }

    &::-webkit-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &::-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-ms-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }
  }

  .code {
    width: 6rem;
    text-align: right;
    padding-right: 0.75rem;
    @include dynamic-color;

    &.disabled {
      color: $explain-color !important;
    }
  }
}

.credit-popup {
  .popup {
    width: 12rem;
    line-height: 1;
    border-radius: 1.25rem;

    .content {
      text-align: justify;
      padding: 0.75rem;

      .txt {
        font-size: $title4;
        color: $word-color;
      }
    }

    .btn {
      font-size: $title4;
      @include dynamic-color;
      text-align: center;
      padding: 0.7rem 0;
      border-top: 1px solid $border-color;

      &.cancel {
        color: $word-color !important;
      }
    }
  }
}
</style>
